import React from 'react'
import { AppBar, Toolbar, Typography, withStyles, WithStyles } from '@zn-material-ui'
import { Login } from '@services/api'
import { withSnackbar, withSnackbarProps } from 'notistack'
import { DropDownList } from '@components/Select'
import Select from '@components/Select'
import DataTracker from '@common/dataTracker'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import { IUserStore } from '@stores/UserStore'
import { IAppStore } from '@stores/AppStore'
import { IHomeStore } from '@stores/Home'
import { IExamStore } from '@stores/ExamStore'
import { ExamStage } from '@const/exam'
import Store from 'store'
import { toLogin, getOriginFromUrl, toLoginOutTo37, enterpriseIdSqList, enterpriseIdGZList, loginOutToManage } from '@utils'
import SearchBox from './SearchBox'
import styles from './styles/AppBar'
import { PcVersionEnum } from '@services/api/Common'
import { transform } from '@utils/intl_lang'
// zn-i18n-disable-next-line
const DATATREACKER_KEY = '01Web-智门户首页'

export interface IProps
  extends withSnackbarProps,
    WithStyles<typeof styles>,
    RouteComponentProps {
  pushMessage?: string
  HomeState?: IHomeStore
  UserStore?: IUserStore
  AppStore?: IAppStore
  ExamStore?: IExamStore
  Search?: any
}
interface IState {
  open: boolean
  homeVal: string
}

@inject('UserStore', 'HomeState', 'AppStore', 'ExamStore', 'Search')
@observer
class PrimarySearchAppBar extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    const homeVal = props.UserStore
      ? props.UserStore.homeId
      : Store.get('homeId')
    this.state = {
      open: false,
      homeVal,
    }
  }

  public componentDidMount() {
    const { UserStore, HomeState } = this.props
    HomeState!.getHomeInfo(UserStore!.homeId)
  }

  public componentDidUpdate(nextProps: IProps) {
    const homeVal = (nextProps.UserStore && nextProps.UserStore.homeId) || ''
    if (homeVal !== this.state.homeVal) {
      this.setState({ homeVal })
    }
  }

  // 因为考试页比较特殊，在考试页跳转需要从url上获取origin
  private getOrigin = () => {
    if (this.isExamDetailPage()) {
      return getOriginFromUrl() || ''
    }
    return ''
  }

  private goToHomePage = () => {
    this.goToPage('/home/homePage')
  }

  private goToMyNews = () => {
    this.goToPage('/home/MyNews')
  }

  private goToPage = (url: string) => {
    const { ExamStore } = this.props
    const origin = this.getOrigin()
    if (origin) {
      if (ExamStore!.examStage === ExamStage.exam) {
        // '考试中途不允许退出'
        global.$message(transform('not_allow_quit'))
      } else {
        const prefix =
          origin.indexOf('localhost') > -1 ? origin : origin + '/znWeb/znPortal'
        location.href = `${prefix}/#${url}`
      }
    } else {
      this.props.history.push(url)
    }
  }

  private disableSearchBox = () => {
    let disabled = false
    if (
      this.isExamDetailPage() &&
      this.props.ExamStore!.examStage === ExamStage.exam
    ) {
      disabled = true
    }
    return disabled
  }

  private isExamDetailPage = () => {
    return location.href.indexOf('/home/examDetail') > -1
  }

  public render() {
    // console.log(this.props.location.pathname)
    const url = this.props.location.pathname
    const { classes, HomeState, UserStore, AppStore } = this.props
    const logoUrl = HomeState!.homeGlobalInfo.logoUrl
    const data = AppStore
      ? AppStore.homeList.map(v => ({ title: v.pageName, value: v.pageId }))
      : []

    return (
      <div className={classes.root}>
        <AppBar position="static" color="secondary" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <Typography className={classes.title} variant="h6" noWrap={true}>
              <div
                className={classes.logo}
                onClick={this.goToHomePage}
                style={{
                  backgroundImage: `url(${logoUrl})`,
                }}
              />
              {(data.length > 0 && (
                <div style={{ marginTop: 30, marginBottom: 40 }}>
                  <Select
                    showTip={false}
                    lineHeight={30}
                    data={data}
                    containerStyle={classes.containerStyle}
                    titleStyle={classes.titleStyle}
                    listItemStyle={classes.listItemStyle}
                    defaultValue={this.state.homeVal}
                    onChange={this.onChange}
                  />
                </div>
              )) ||
                null}
            </Typography>
            <div className={classes.grow} />
            <span>
              <SearchBox
                history={this.props.history}
                disabled={this.disableSearchBox()}
              />
            </span>
            <div className={classes.sectionDesktop}>
              {(HomeState && HomeState.IS_OP_TOB_PAY && (
                <div onClick={this.toWallet} className={classes.toolsItem}>
                  <span className={classes.packetImg} />
                  {/* 钱包 */}
                  {transform('wallet')}
                </div>
              )) ||
                null}
              <div className={classes.toolsItem} onClick={this.goToMyNews}>
                <span
                  className={classes.messageImg}
                  data-event-category={DATATREACKER_KEY}
                  // zn-i18n-disable-next-line
                  data-event-label="0103Web-查看消息"
                  data-event-mapkv={JSON.stringify({
                    // zn-i18n-disable-next-line
                    from: '01Web-智门户首页',
                  })}
                >
                  {HomeState && HomeState.pushMessage !== 'N' && (
                    <span className={classes.count} />
                  )}
                </span>
                {/* 消息 */}
                {transform('news')}
              </div>
              <div
                aria-owns={this.state.open ? 'material-appbar' : undefined}
                aria-haspopup="true"
                onClick={this.handleProfileMenuOpen}
                className={classes.userInfo}
                style={{ position: 'relative' }}
              >
                <img src={UserStore!.avatar} className={classes.profile} />
                <DropDownList
                  style={classes.list}
                  data={[
                    // 重设密码
                    { title: transform('reset_password'), value: '0' },
                    // 退出登录
                    { title: transform('logout'), value: '1' },
                  ]}
                  open={this.state.open}
                  onChange={value => {
                    if (value === '0') {
                      this.linkResetPwd()
                    } else {
                      this.logout()
                    }
                  }}
                  onClose={() => this.setState({ open: false })}
                />
                <div className={classes.userName}>{UserStore!.userName}</div>
              </div>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    )
  }

  private onChange = async (value: string) => {
    if (
      this.isExamDetailPage() &&
      this.props.ExamStore!.examStage === ExamStage.exam
    ) {
      // '考试中途不允许退出'
      global.$message(transform('not_allow_quit'))
      return
    }

    const { AppStore, HomeState } = this.props
    this.props.Search.updateLiteHasData(true)
    this.props.Search.updateLiteListData([])
    this.setState({ homeVal: value })
    if (AppStore) {
      const home = AppStore.homeList.find(v => v.pageId === value)
      if (home) {
        if (HomeState && home.isOpenPcVersion === PcVersionEnum.true) {
          const moduleList = await HomeState.queryHomeChannelModule(home.pageId)
          HomeState.setModuleList(moduleList)
        }
        if (HomeState) {
          HomeState.getHomeInfo(home.pageId) // 切换首页全局信息重新请求
        }
        AppStore.setTheme(home.pageId, home.isOpenPcVersion)
        this.goToPage('/home/homePage')
      }
    }
  }
  private handleProfileMenuOpen = () => {
    const dataTracker = {
      category: DATATREACKER_KEY,
      // zn-i18n-disable-next-line
      label: '0104Web-点击头像',
      mapkv: {
        // zn-i18n-disable-next-line
        from: '01Web-智门户首页',
      },
    }
    DataTracker.singleTrackEvent(dataTracker)
    this.setState({ open: true })
  }

  private toWallet = () => {
    const dataTracker = {
      category: DATATREACKER_KEY,
      // zn-i18n-disable-next-line
      label: '0102Web-查看钱包',
      mapkv: {
        // zn-i18n-disable-next-line
        from: '01Web-智门户首页',
      },
    }
    DataTracker.singleTrackEvent(dataTracker)
    window.open('/znWeb/moneyBag.html', '_blank')
  }

  private linkResetPwd = () => {
    if (
      this.isExamDetailPage() &&
      this.props.ExamStore!.examStage === ExamStage.exam
    ) {
      // '考试中途不允许退出'
      global.$message(transform('not_allow_quit'))
      return
    }
    const dataTracker = {
      category: DATATREACKER_KEY,
      // zn-i18n-disable-next-line
      label: '0106Web-我的设置',
      mapkv: {
        // zn-i18n-disable-next-line
        from: '01Web-智门户首页',
      },
    }
    DataTracker.singleTrackEvent(dataTracker)
    this.goToPage('/home/resetPassword')
  }

  private logout = () => {
    if (
      this.isExamDetailPage() &&
      this.props.ExamStore!.examStage === ExamStage.exam
    ) {
      // '考试中途不允许退出'
      global.$message(transform('not_allow_quit'))
      return
    }

    const dataTracker = {
      category: DATATREACKER_KEY,
      // zn-i18n-disable-next-line
      label: '0107Web-退出登录',
      mapkv: {
        // zn-i18n-disable-next-line
        from: '01Web-智门户首页',
      },
    }
    DataTracker.singleTrackEvent(dataTracker)
    const { enqueueSnackbar } = this.props
    this.props.Search.updateLiteHasData(true)
    this.props.Search.updateLiteListData([])
    Login.logout()
      .then((res: any) => {
        if (res.code * 1 === 0) {
          const { enterpriseId = '' } = Store.get('sessionInfo') || {}
          // 三七互娱不同环境的企业Id
          if (enterpriseIdSqList.includes(enterpriseId)) {
            toLoginOutTo37()
          } else if (enterpriseIdGZList.includes(enterpriseId)) {
            loginOutToManage()
          } else {
            toLogin()
          }
        } else if (res.code * 1 !== -4) {
          // '请求出错'
          enqueueSnackbar(res.message || transform('error'), {
            variant: 'error',
            autoHideDuration: 2000,
          })
        }
      })
      .catch(err => {
        console.log('error', err)
      })
  }
}

export default withStyles(styles)(withSnackbar(withRouter(PrimarySearchAppBar)))
